
import {AbstractDTO} from "@signature-it/ngx-generic/models";
import {OwlOptions} from "ngx-owl-carousel-o/lib/models/owl-options.model";

export class SolrGroupedPreviewConfig extends AbstractDTO {
    groupField: string;
    solrProductKey: string;
    sort: string;
    extraQryString: string;
    layout: string;
    entityPreviewVar: string;
    carouselConfig: OwlOptions;
    carouselItemsWidth: number;
    responsive: {};
    showGroupedItems: boolean;
    groupedItemPreviewVar: string;
    groupExtraQryString: string;
    mobileLayout: boolean;
    limitShowMore: number;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes ? attributes : {};
        this.groupField  = attributes['groupField'] || '';
        this.groupExtraQryString  = attributes['groupExtraQryString'] || '';
        this.layout  = attributes['layout'] || '';
        this.entityPreviewVar  = attributes['entityPreviewVar'] || '';
        this.solrProductKey  = attributes['solrProductKey'] || '';
        this.extraQryString  = attributes['extraQryString'] || '';
        this.carouselConfig  = attributes['carouselConfig'] || {};
        this.responsive  = attributes['responsive'] || {};
        this.showGroupedItems  = attributes['showGroupedItems'] == '1' ? true: false;
        this.mobileLayout  = attributes['mobileLayout'] == '1' ? true: false;
        this.groupedItemPreviewVar  = attributes['groupedItemPreviewVar'] || '';
        this.carouselItemsWidth = attributes['carouselItemsWidth'] || '';
        this.limitShowMore = attributes['limitShowMore'] || '';
        this.sort = attributes['sort'] || null;
    }
}
